import { render } from "./QuestionsView.vue?vue&type=template&id=5126c77e"
import script from "./QuestionsView.vue?vue&type=script&lang=js"
export * from "./QuestionsView.vue?vue&type=script&lang=js"

import "./QuestionsView.vue?vue&type=style&index=0&id=5126c77e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__